let hasErrors = false;

export function setKwargsErrors(value: boolean): void {
  hasErrors = value;
}

export function getKwargsHasErrors(): boolean {
  return hasErrors;
}
